module.exports = __webpack_public_path__ + "img/c531ea6.png";